import { render } from "./LoadingView.vue?vue&type=template&id=31eabd52&scoped=true"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=31eabd52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-31eabd52"

export default script